module.exports = __webpack_public_path__ + "img/equipos-moviles.e47ce440.jpg";